/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.before-after-slider-outer' ).slick( {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: $( '.before-after-nav-wrapper' ),
        prevArrow: '<button type="button" class="text-brand-violet hdg-6 group"><svg class="lg:group-hover:-translate-x-2 duration-150 icon h-8 w-8 icon-left-arrow mb-1 mr-5"><use xlink:href="#icon-left-arrow"></use></svg> Previous</button>',
        nextArrow: '<button type="button" class="text-brand-violet hdg-6 group">Next <svg class="lg:group-hover:translate-x-2 duration-150 icon h-8 w-8 ml-5 mb-1 icon-right-arrow"><use xlink:href="#icon-right-arrow"></use></svg></button>',
      } );
      $( function() {
        $( '.before-and-after-slider' ).each( function() {
          const $colorBlockBG = $( this ).find( '.ba-background' ).outerHeight();
          const imgOverlap = 128;
          const $image = $( this ).find( '.slide-wrapper' );
          $image.css( {'height': `${ $colorBlockBG + imgOverlap + 'px'}`} );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
